import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Order } from '@spartacus/order/root';

import { Observable } from 'rxjs';
import { CheckoutFacade } from '../../../../root';

@Component({
  selector: 'cx-order-confirmation-totals',
  templateUrl: './order-confirmation-totals.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OrderConfirmationTotalsComponent implements OnInit, OnDestroy {
  order$!: Observable<Order>;

  constructor(protected checkoutService: CheckoutFacade) {}

  ngOnInit() {
    this.order$ = this.checkoutService.getOrderDetails();
  }

  ngOnDestroy() {
    this.checkoutService.clearCheckoutData();
  }
}
